import {AxiosError} from 'axios';
import {useMutation, useQueryClient} from 'react-query';
import {toast} from 'react-toastify';
import {getPersianErrorCode} from '../../../global/helpers/ErrorCodes/ErrorCode';

import {patchDirectLoanRequest} from './patchDirectLoanRequest';

export interface ErrorResponse {
  error_code?: string;
}

interface UsePatchDirectLoanRequestProps {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ErrorResponse>) => void;
}

const usePatchDirectLoanRequest = ({
  onSuccess,
  onError,
}: UsePatchDirectLoanRequestProps = {}) => {
  const queryClient = useQueryClient();

  const {mutate, isLoading} = useMutation({
    mutationFn: (payload: IPatchDirectLoanRequestPayload) =>
      patchDirectLoanRequest(payload),

    onSuccess: async () => {
      await queryClient.refetchQueries('get-list-loan-request');

      onSuccess?.();
    },

    onError: (error: AxiosError<ErrorResponse>) => {
      onError?.(error);

      const status = error.response?.status;

      if (status === 400) {
        const errorCode = error.response?.data?.error_code;

        if (errorCode) {
          toast.error(getPersianErrorCode(errorCode));

          return;
        }
      }
    },
  });

  return {mutate, isLoading};
};

export default usePatchDirectLoanRequest;
